import {inject} from "@angular/core";
import {PiwikService} from "./piwik.service";
import {config} from "../../../config";
import {HttpEvent, HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs/internal/Observable";
import {from} from "rxjs/internal/observable/from";
import {switchMap} from "rxjs/internal/operators/switchMap";
import {AppReadyChecker} from "../../app.init";



export function withPiwikHeaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const url = new URL(req.url);
  if (url.origin !== config.endpoints.api) {
    return next(req);
  }
  const piwik = inject(PiwikService);
  const appReady = inject(AppReadyChecker);
  if (!appReady()) {
    return next(req);
  }


  return from((async () => {

    try {
      const info = await piwik.tryReadUserInfo();
      if (!info?.visitorId?.length) {
        return req;
      }
      return req.clone({
        headers: req.headers.set('X-Piwik-Session', info.visitorId),
      });
    } catch (e) {
      console.error(e, 'Error setting piwik header');
      // fail silently
      return req;
    }

  })())
    .pipe(switchMap(next))
}
